import {css} from 'lit';
export const styles = css`ef-avatar-list {
  --avatar-size: 40px;
  --avatar-border: 2px solid var(--contrast-light);
  --avatars-overlap: 10px;
  --label-padding: 0 0 0 8px;
  --label-font-weight: 700;
  --label-text: var(--dark-text-secondary);
  --label-font-size: var(--font-size-base);
}

:host {
  --card-padding: 16px;
  --card-background: var(--contrast-light);
  --card-font-color: var(--dark-text);
  --card-font-color-secondary: var(--dark-text-secondary);

  display: block;
  position: relative;
  color: var(--card-font-color);
  background-color: var(--card-background);
  border-radius: var(--border-radius);
}

.body {
  position: relative;
  padding-left: var(--card-padding);
  padding-right: var(--card-padding);
}

.body ef-label {
    position: absolute;
    font-weight: 600;
    margin-bottom: 16px;
    z-index: 2;
  }

.attachment-list {
  margin-top: 32px;
}

.attachment-list h3 {
  position: relative;
  display: inline-block;
  z-index: 1;
}

.attachment-list h3::before {
    content: '';
    position: absolute;
    top: -2px;
    right: -8px;
    bottom: -2px;
    left: -8px;
    background-color: var(--warning-100);
    border-radius: var(--border-radius);
    opacity: 0;
    z-index: -1;
    transition: opacity var(--transition-duration) var(--transition-timing);
  }

.attachment-list h3.scrolled-to::before {
      opacity: 1;
    }

slot[name='title']::slotted(*) {
  margin-top: 28px;
  margin-bottom: 16px;
}

slot[name='body']::slotted(.long) {
  color: var(--card-font-color-secondary);
}

slot[name='attachments']::slotted(ef-attachment) {
  display: block;
  margin-bottom: 16px;
}

.truncate::slotted(.long) {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

xs-card-date-widget {
  position: absolute;
  top: var(--card-padding);
  right: 16px;
  z-index: 1;
}

ef-img-placeholder {
  --font-size-primary: 55px;
  --text-primary: var(--gray-400);

  width: auto;
  height: 92px;
  margin-left: calc(-1 * var(--card-padding));
  margin-right: calc(-1 * var(--card-padding));
  border-radius: 0;
}

xs-origin {
  margin-top: 28px;
}

.subtitle {
  margin-bottom: 16px;
}

.event-actions {
  margin-bottom: 28px;
}

.card-actions {
  margin-top: 28px;
  margin-bottom: 28px;
}

.card-actions > button {
    width: 100%;
  }

xs-card-prefooter {
  margin-top: 28px;
}

footer ef-list-item-10 {
  padding: var(--card-padding);
  border-radius: 0;
  border-bottom-left-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
  background-color: var(--contrast-light);
}

footer ef-list-item-10 button {
    padding: 4px;
  }

details summary {
  display: none;
}

footer button {
  display: flex;
  align-items: center;
  border: none;
  background: none;
  color: var(--card-font-color);
}

footer button > ef-icon {
    font-size: 20px;
  }

footer button > .count {
    margin-left: 6px;
    font-size: var(--font-size-base);
  }

@media (hover: hover) {
  footer button:hover {
    color: var(--link-text-hover);
  }
}

footer button:active {
  color: var(--link-text-active);
}

footer button.focus-visible {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: var(--link-focus-outline-offset);
}

footer button:focus-visible {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: var(--link-focus-outline-offset);
}

:host([isAnnouncement]) {
  --card-background: var(--contrast-dark);
  --card-font-color: var(--light-text);
  --card-font-color-secondary: var(--light-text-secondary);
  --link-text-hover: var(--primary-200);
}

:host([isAnnouncement]) footer ef-list-item-10 {
    background-color: var(--contrast-dark);
  }

:host([isAnnouncement]) xs-btn-more {
    --btn-more-color: var(--light-text);
  }
`;
export default styles;
